import { ElMessage } from 'element-plus'

export const showMessage = (message:string,type:string) => {
    ElMessage({
        message: message,
        type: type,
    })
}
